module.exports = __webpack_public_path__ + "img/Inventory.9c5edebd.jpg";